import { RenderLayoutError } from "../errors";
import type { PositionedElement } from "../types/template";
import type { Rect } from "./anchorPlacement";

export function assertFitsInside(
  parent: Rect,
  element: PositionedElement,
  overflow: "error" | "clip",
  context: string,
): void {
  if (overflow !== "error") {
    return;
  }

  const epsilon = 0.001;
  const isOutside =
    element.xMm < parent.x - epsilon ||
    element.yMm < parent.y - epsilon ||
    element.xMm + element.widthMm > parent.x + parent.width + epsilon ||
    element.yMm + element.heightMm > parent.y + parent.height + epsilon;

  if (isOutside) {
    throw new RenderLayoutError(
      `${context} overflowed bounds. Element '${element.element.id}' at ${element.xMm},${element.yMm} with size ${element.widthMm}x${element.heightMm} mm exceeds container.`,
    );
  }
}
